import { CountUp } from 'countup.js/dist/countUp.min.js';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import SplitType from 'split-type';

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

import bodymovin from "lottie-web";

jQuery(document).ready(function($) {
	var windowWidth = $(window).width()

/* ====================== Extension CTA ======================  */
    $('.extension-link-container .close').on("click", function() {
        $('.extension-link-container').hide();
    })

/* ====================== Semi Sticky Nav ======================  */
	var prevScrollpos = window.pageYOffset;
	var currentScrollPos = window.pageYOffset;

	if(currentScrollPos > 120) {
		$("header").addClass("headerscrolled");
	}

	document.addEventListener('scroll', function (event) {
		var currentScrollPos = window.pageYOffset;

		if ((prevScrollpos > currentScrollPos)) {
			$('header').addClass('show');
		} else if((prevScrollpos < currentScrollPos)){
			$('header').removeClass('show');
		}
		else {
			$('header').removeClass('show');
		}

		if(currentScrollPos > 120) {
			$("header").addClass("headerscrolled");
		} else {
			$("header").removeClass("headerscrolled show");
		}

		prevScrollpos = currentScrollPos;
	}, true);

/* ====================== Accordion ======================  */
	$('.accordion .row-title').on('click', function () {
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).next('.row-content').slideUp();
			$(this).next('.row-content').removeClass('active');
		} else {
			$('.accordion .row-title').removeClass('active');
			$('.row-content').slideUp();
			$('.row-content').removeClass('active');

			$(this).addClass('active');
			$(this).next('.row-content').slideDown();
			$(this).next('.row-content').addClass('active');
		}
    });

/* ====================== Prevent Widows ======================  */
	$('p, h2, h3, h4').each(function() {
		var html = $(this).html();
		var words = html.split(/ (?=[^>]*$)/);

		if (words.length > 1) {
			var lastWord = words.pop();
			var secondLastWord = words.pop();
			$(this).html(words.join(' ') + ' ' + secondLastWord + '&nbsp;' + lastWord);
		}
	});

/* ====================== Splitlines ======================  */
	const headingMask = new SplitType('h1:not(.no-anim),h2:not(.no-anim),h3:not(.no-anim),h4:not(.no-anim), .product-masthead p:first-of-type',
	{ types: 'lines,words' })
	headingMask.lines

	let headingMaskAnim = gsap.utils.toArray('h1:not(.no-anim):not(.homepage-title), h2:not(.no-anim), h3:not(.no-anim), .product-masthead p:first-of-type');
	headingMaskAnim.forEach((item, index) => {
		item.style.opacity = 1;

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				once: true,
				start: 'top 85%',
				toggleActions:"restart none none reset",
				end: "500",
				markers: false,
				toggleClass: 'animateelement'
			}
		}, 1);
	});

/* ====================== MOBILE NAV ======================  */
    $('.menu-toggle').on("click", function() {
        $(this).toggleClass('active');
        $('.main-nav').toggleClass('open');
        $('header').toggleClass('open');
        $('body').toggleClass('noscroll');
    })

    if(windowWidth < 768) {
	    $('.collapsed-on-mobile h5').on("click", function() {
	    	$(this).next('ul').slideToggle();
	       $(this).toggleClass('open');
	    })

	    $('.sub-menu a').on("click", function(event) {
	        event.stopPropagation();
	    });
	}

/* ====================== Init Fancybox ======================  */
	Fancybox.bind("[data-fancybox]", {
	});

/* ====================== Testimonials Carousel ======================  */
	const testimonials_carouse = new Swiper('.testimonials-carousel .swiper', {
       	slidesPerView: 1.7,
       	speed: 600,
       	loop: false,
       	watchSlidesProgress: true,
       	spaceBetween: 24,
       	navigation: {
			nextEl: ".testimonials-carousel .swiper-button-next",
			prevEl: ".testimonials-carousel .swiper-button-prev",
		},
		breakpoints: {
			325: {
				spaceBetween: 12,
				slidesPerView: 1.01,
			},
			767: {
				slidesPerView: 1.2,
			},
			1023: {
				slidesPerView: 1.7,
			},
		}
	});

/* ====================== Cards Carousel ======================  */
	if(windowWidth > 768) {
		const cards = new Swiper('.cards.swiper-active .cards-container', {
	       	slidesPerView: 4.1,
	       	speed: 600,
	       	loop: false,
	       	watchSlidesProgress: true,
	       	spaceBetween: 24,
	       	navigation: {
				nextEl: ".cards.swiper-active .swiper-button-next",
				prevEl: ".cards.swiper-active .swiper-button-prev",
			},
			breakpoints: {
				767: {
					slidesPerView: 2.1,
				},
				1023: {
					slidesPerView: 2.4,
				},
				1279: {
					slidesPerView: 4.1,
				},
			}
		});
	}

/* ====================== GSAP ======================  */
	let animate = gsap.utils.toArray('.animate')
	animate.forEach((item, index) => {
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				once: true,
				start:"0 85%",
				toggleActions:"restart none none reset",
				end: "500",
				markers: false,
				toggleClass: 'animateelement'
			}
		});
	});

	/* ====================== Standalone Video ======================  */
	let videoCols = gsap.utils.toArray('.video-and-content-columns video');
	videoCols.forEach((item, index) => {
		ScrollTrigger.create({
			trigger: item,
			markers: false,
			start: "top 50%",
			end: "bottom 50%",
			once: false,
			markers: false,
			onEnter: () => {
				item.play();
			},
			onLeave: () => {
				item.pause();
			},
			onEnterBack: () => {
				item.play();
			},
			onLeaveBack: () => {
				item.pause();
			}
		});
	});


	/* ====================== Standalone Video ======================  */
	let video = gsap.utils.toArray('.standalone-video .video-placeholder');
	video.forEach((item, index) => {
		let tl = gsap.timeline({
		scrollTrigger: {
			scrub: 1,
			trigger: item,
			start:"-200 80%",
			toggleActions:"restart none none reset",
			end: "50% 70%",
			markers: false
		}
		});
		tl.to(item, {
			width: '100%',
			borderRadius: 0,
		});
	});

/* ====================== Stats ======================  */
	$('.stats span').each(function(){
		var endVal = $(this).text()

		if (endVal.includes('.')) {
			const countUp = new CountUp(this, endVal, { enableScrollSpy: true, decimalPlaces: 1 });
		} else {
			const countUp = new CountUp(this, endVal, { enableScrollSpy: true});
		}
	});

/* ====================== Submit Gravity Form ======================  */
	$(document).on('gform_post_render', function(){
	     $('.gform_wrapper .submit').on('click', function() {
        	$(this).parents('.gform_wrapper').find('input[type=submit]').click();
        });
	});

/* ====================== LOTTIE ANIMATION  ======================  */
	$('.illustration-container').each(function() {
		var el = $(this);
		var path =  $(this).attr('lottie-related');

		if(windowWidth < 767 && $(el).attr('mobile-lottie-related')) {
			path =  $(this).attr('mobile-lottie-related');
		}

		var dataIntro = {
			container: el[0],
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path: path
		};

		var animIntro = bodymovin.loadAnimation(dataIntro);
		setTimeout( function() {
			animIntro.play();
		}, 750);
	});

/* ====================== MOBILE NAV ======================  */
    $('.news-filters .trigger').on("click", function() {
        $(this).toggleClass('active');

        $('.hidden-filters').toggle();
    })


/* ====================== Sticky Mobile Filters ======================  */
    if(windowWidth < 768) {
    	if($('.news-filters').length) {
		    $(window).on('scroll', function() {
		        var $element = $('.mobile-filters-container');
		        var windowHeight = $(window).height();
		        var scrollTop = $(window).scrollTop();
		        var elementOffset = $element.offset().top;
		        var elementHeight = $element.outerHeight();

		        if (scrollTop + windowHeight > elementOffset + elementHeight) {
		        	$('.mobile-filters').addClass('stuck');
		        } else if(scrollTop + windowHeight < elementOffset - elementHeight) {
		        	$('.mobile-filters').removeClass('stuck');
		        }
		    });
    	}
	}

/* ====================== Smooth Scroll - Doesn't conflict with ajax smooth scroll ======================  */
	$("a").on('click', function(event) {
		if (this.hostname === window.location.hostname) {
		if (this.hash !== "") {
		  event.preventDefault();
		  var hash = this.hash;
		  $('html, body').animate({
		    scrollTop: $(hash).offset().top
		  }, 500, function(){

		    window.location.hash = hash;
		  });
		}
	}
	});

	/* ====================== Whitepaper Modal ======================  */
	    const whitepaperModal = document.getElementById('whitepaper-popup');
	    if(whitepaperModal) {
		    $('.whitepaper-trigger').on("click", function() {
		    	var whitepaper_id = $(this).attr('whitepaper-related');
		    	var whitepaper_name = $(this).attr('whitepaper-related-title');

		    	$('#whitepaper-popup .whitepaper-id input').val(whitepaper_id);
		    	$('#whitepaper-popup .whitepaper-name input').val(whitepaper_name);

		        whitepaperModal.showModal();
		        $('body').toggleClass('noscroll');
		    })

		    window.addEventListener('click', (event) => {
		      if (event.target === whitepaperModal) {
		          whitepaperModal.close();
		          $('body').removeClass('noscroll');
		      }
		    });
		}

	/* ====================== Talis Courseflow Modal ======================  */
	    const locationModal = document.getElementById('location-popup');
	    const locationModalClose = document.getElementById('location-close');
	    if(locationModal) {
		    setTimeout( function() {
				locationModal.showModal();
	    		$('body').toggleClass('noscroll');
			}, 2000);

		    window.addEventListener('click', (event) => {
		      if (event.target === locationModal) {
		          locationModal.close();
		          $('body').removeClass('noscroll');
		      }
		    });

		    locationModalClose.addEventListener('click', () => {
		      locationModal.close();
		      $('body').removeClass('noscroll');
		    });
		}

		$('.location-prompt').on("click", function() {
	        $(this).toggleClass('active');
	    })

	/* ====================== Pinned Section ======================  */
	if(windowWidth > 1023) {
		let transitionVal = $('.stacked-rows .row').length - 1;
		let stackedRows = gsap.utils.toArray('.stacking-content-and-image .row:not(:first-of-type)');
		let initalHeight = $('.stacked-rows').outerHeight();

		let totalHeight = 0;
		let finalPosition = 0;
		stackedRows.forEach((item, index) => {
			totalHeight += $(item).outerHeight();
			let rowHeight = $(item).outerHeight();
			finalPosition = rowHeight - 55;

			let tl = gsap.timeline({
			scrollTrigger: {
				scrub: 1,
				trigger: item,
				start:"0 60%",
				toggleActions:"restart none none reset",
				end: "bottom"+ rowHeight,
				markers: false
			}
			});
			tl.to(item, {
				marginTop: '-' + finalPosition + 'px',
			});
		});
		let rowsfinalHeight = initalHeight - (finalPosition - 55) * transitionVal;
		$('.stacked-rows').height(rowsfinalHeight);

		let stackedRowsHeight = $('.stacked-rows').outerHeight();
		let scrollTween = gsap.to(".stacked-rows", {
			scrollTrigger: {
				pin: ".stacked-rows",
				trigger: ".stacked-rows",
				start: "top top",
				end: '+='+ totalHeight,
				markers: false,
			}
		});
	}
});
